import React from 'react';
import './footer-login-method.less';
import {Link, useLocation} from 'react-router-dom';
import {Utils} from '../../../../../tools/utils';

export const loginMethod = {
    '微信扫码登录': '0',
    '手机号登录': '1',
}

const FooterLoginMethod = ({type = loginMethod.微信扫码登录}) => {

    const {search} = useLocation();
    const merchantBelong = new URLSearchParams(search).get('merchantBelong');
    const query = merchantBelong ? `?merchantBelong=${merchantBelong}` : ''

    return (
        <div className="footer-login-method">
            {
                type === loginMethod.手机号登录
                    ? <Link to={`/login${query}`}>
                        <div className="footer-content" onClick={() => {
                            // Utils.customTrack('MerchantLoginClick', {
                            //     element_content: '手机号登录'
                            // });
                        }}>
                            <img src={require('@/assets/images/phone.png')} alt=""/>
                            <span>手机号登录</span>
                        </div>
                    </Link>
                    : <Link to={`/login/qrcode${query}`}>
                        <div className="footer-content" onClick={() => {
                            // Utils.customTrack('MerchantLoginClick', {
                            //     element_content: '扫码登录'
                            // });
                        }}>
                            <img src={require('@/assets/images/wechat.png')} alt=""/>
                            <span>微信扫码登录</span>
                        </div>
                    </Link>
            }
        </div>
    )
}

export default FooterLoginMethod;
